import Hubx from "./HubX";
import AuthenticationService from "./services/AuthenticationService";
import UserService from "./services/UserService";
import CustomerService from "./services/CustomerService";
import InstallationService from "./services/InstallationService";
import InstallationLevelService from "./services/InstallationLevelService";
import TankLevelService from "./services/TankService";
import InstallationConsumptionService from "./services/InstallationConsumption";
import NotificationService from "./services/NotificationService";
import ExportFileService from "./services/ExportFileService";
import OrganizationService from "./services/OrganizationService";
import DirectorShipService from "./services/DirectorShipService";
import InstallationGroupService from "./services/InstallationGroupService";
import UserFavoriteInstallationsService from "./services/UserFavoriteInstallationsService";
import FilterService from "./services/FilterService";
import VideoAfterSalesService from "./services/VideoAfterSalesService";

// Ordered alphabetically to facilitate maintenance
export const ADD_OR_REMOVE_FAVORITE_INSTALLATION = "ADD_OR_REMOVE_FAVORITE_INSTALLATION";
export const COUNT_DIRECTORIES = "COUNT_DIRECTORIES";
export const COUNT_ORGANIZATIONS = "COUNT_ORGANIZATIONS";
export const DELETE_INSTALLATION_GROUP = "DELETE_INSTALLATION_GROUP";
export const DELETE_USERS_FROM_INSTALLATION_GROUPS = "DELETE_USERS_FROM_INSTALLATION_GROUPS";
export const DELETE_INSTALLATIONS_FROM_INSTALLATION_GROUPS = "DELETE_INSTALLATIONS_FROM_INSTALLATION_GROUPS";
export const DO_LOGIN = "DO_LOGIN";
export const DO_NOTIFICATION_READED = "DO_NOTIFICATION_READED";
export const DO_RENEW_AUTH_TOKEN = "DO_RENEW_AUTH_TOKEN";
export const DO_RESET_AUTHENTICATION = "DO_RESET_AUTHENTICATION";
export const DO_RESET_PASSWORD = "DO_RESET_PASSWORD";
export const DO_RESET_TOKEN_VALIDATE = "DO_RESET_TOKEN_VALIDATE";
export const DO_SEARCH_INSTALLATION = "DO_SEARCH_INSTALLATION";
export const DO_SEND_RESET_PASSWORD = "DO_SEND_RESET_PASSWORD";
export const DO_UPDATE_DIRECTORIES = "DO_UPDATE_DIRECTORIES";
export const DO_UPDATE_ORGANIZATION = "DO_UPDATE_ORGANIZATION";
export const DO_UPDATE_PUSH_USER_TOKEN = "DO_UPDATE_PUSH_USER_TOKEN";
export const FETCH_ALL_INSTALLATIONS = "FETCH_ALL_INSTALLATIONS";
export const FETCH_ALL_INSTALLATIONS_FILTERS = "FETCH_ALL_INSTALLATIONS_FILTERS";
export const FETCH_ALL_USERS = "FETCH_ALL_USERS";
export const FETCH_ALL_NON_ADMIN_USERS = "FETCH_ALL_NON_ADMIN_USERS";
export const FETCH_CACHEABLE_CUSTOMERS = "FETCH_CACHEABLE_CUSTOMERS";
export const FETCH_CUSTOMERS = "FETCH_CUSTOMERS";
export const FETCH_CUSTOMERS_BY_GROUP = "FETCH_CUSTOMERS_BY_GROUP";
export const FETCH_DIRECTORIES = "FETCH_DIRECTORIES";
export const FETCH_EXCEL_FILE_CONSUMPTION_HISTORY = "FETCH_EXCEL_FILE_CONSUMPTION_HISTORY";
export const FETCH_EXCEL_FILE_LEVEL_HISTORY = "FETCH_EXCEL_FILE_LEVEL_HISTORY";
export const FETCH_EXCEL_FILE_TRIPS_HISTORY = "FETCH_EXCEL_FILE_TRIPS_HISTORY";
export const FETCH_GROUPS = "FETCH_GROUPS";
export const FETCH_GROUPS_AND_USERS_FILTERED = "FETCH_GROUPS_AND_USERS_FILTERED";
export const FETCH_INSTALLATION = "FETCH_INSTALLATION";
export const FETCH_INSTALLATIONS_AND_GROUPS_FILTERED = "FETCH_INSTALLATIONS_AND_GROUPS_FILTERED";
export const FETCH_INSTALLATIONS_IDS = "FETCH_INSTALLATIONS_IDS";
export const FETCH_INSTALLATION_CONSUMPTION = "FETCH_INSTALLATION_CONSUMPTION";
export const FETCH_INSTALLATION_GROUP = "FETCH_INSTALLATION_GROUP";
export const FETCH_INSTALLATION_GROUPS = "FETCH_INSTALLATION_GROUPS";
export const FETCH_INSTALLATION_GROUPS_PAGINATED = "FETCH_INSTALLATION_GROUPS_PAGINATED";
export const FETCH_INSTALLATION_LEVEL_READINGS = "FETCH_INSTALLATION_LEVEL_READINGS";
export const FETCH_INSTALLATION_TRIPS_READINGS = "FETCH_INSTALLATION_TRIPS_READINGS";
export const FETCH_MULTIPLE_INSTALLATIONS = "FETCH_MULTIPLE_INSTALLATIONS";
export const FETCH_MULTIPLE_INSTALLATIONS_CONSUMPTION = "FETCH_MULTIPLE_INSTALLATIONS_CONSUMPTION";
export const FETCH_NOTIFICATION_UNREAD = "FETCH_NOTIFICATION_UNREAD";
export const FETCH_ORGANIZATIONS = "FETCH_ORGANIZATIONS";
export const FETCH_PDF_FILE_FROM_HTML = "FETCH_PDF_FILE_FROM_HTML";
export const FETCH_TANKS_LEVEL_READINGS = "FETCH_TANKS_LEVEL_READINGS";
export const FETCH_TANKS_TRIPS_READINGS = "FETCH_TANKS_TRIPS_READINGS";
export const FETCH_TANKS_READINGS = "FETCH_TANKS_READINGS";
export const FETCH_USER_FAVORITE_INSTALLATIONS = "FETCH_USER_FAVORITE_INSTALLATIONS";
export const FETCH_USER_INFO = "FETCH_USER_INFO";
export const FETCH_USER_INFO_BY_ID = "FETCH_USER_INFO_BY_ID";
export const FILTER_ALL_INSTALLATIONS = "FILTER_ALL_INSTALLATIONS";
export const FILTER_ALL_INSTALLATIONS_NEW = "FILTER_ALL_INSTALLATIONS_NEW";
export const POST_INSTALLATION_GROUP = "POST_INSTALLATION_GROUP";
export const POST_INSTALLATION_TANKS_READINGS = "POST_INSTALLATION_TANKS_READINGS";
export const PUT_INSTALLATION_GROUP = "PUT_INSTALLATION_GROUP";
export const TEST_BEARER_TOKEN = "TEST_BEARER_TOKEN";
export const FETCH_ALL_VIDEOS_AFTER_SALES = "FETCH_ALL_VIDEOS_AFTER_SALES";
export const TEST_FEDX = "TEST_FEDX";

// A Mailbox is a collection of API calls under a common "mailbox" name.
// This maps requests to MAILBOX_NAME to a set of API calls.
// Ordered alphabetically to facilitate maintenance
export default class Fedx {
  build(hubx: Hubx) {
    hubx.attachMediator(ADD_OR_REMOVE_FAVORITE_INSTALLATION, new UserFavoriteInstallationsService().addOrRemoveFavoriteInstallation);
    hubx.attachMediator(COUNT_DIRECTORIES, new DirectorShipService().count);
    hubx.attachMediator(COUNT_ORGANIZATIONS, new OrganizationService().count);
    hubx.attachMediator(DELETE_INSTALLATION_GROUP, new InstallationGroupService().remove);
    hubx.attachMediator(DELETE_USERS_FROM_INSTALLATION_GROUPS, new InstallationGroupService().removeUsersFromInstallationGroups);
    hubx.attachMediator(DELETE_INSTALLATIONS_FROM_INSTALLATION_GROUPS, new InstallationGroupService().removeInstallationsFromInstallationGroups);
    hubx.attachMediator(DO_LOGIN, new AuthenticationService().doLogin);
    hubx.attachMediator(DO_NOTIFICATION_READED, new NotificationService().setNotificationReaded);
    hubx.attachMediator(DO_RENEW_AUTH_TOKEN, new AuthenticationService().renewToken);
    hubx.attachMediator(DO_RESET_AUTHENTICATION, new AuthenticationService().alterPassword);
    hubx.attachMediator(DO_RESET_PASSWORD, new UserService().resetPassword);
    hubx.attachMediator(DO_RESET_TOKEN_VALIDATE, new UserService().validateResetToken);
    hubx.attachMediator(DO_SEARCH_INSTALLATION, new InstallationService().search);
    hubx.attachMediator(DO_SEND_RESET_PASSWORD, new UserService().sendResetPassword);
    hubx.attachMediator(DO_UPDATE_DIRECTORIES, new DirectorShipService().update);
    hubx.attachMediator(DO_UPDATE_ORGANIZATION, new OrganizationService().update);
    hubx.attachMediator(DO_UPDATE_PUSH_USER_TOKEN, new UserService().updatePushToken);
    hubx.attachMediator(FETCH_ALL_INSTALLATIONS, new InstallationService().fetchAll);
    hubx.attachMediator(FETCH_ALL_INSTALLATIONS_FILTERS, new FilterService().fetchAllInstallationsFilter);
    hubx.attachMediator(FETCH_ALL_USERS, new UserService().fetchAll);
    hubx.attachMediator(FETCH_ALL_NON_ADMIN_USERS, new UserService().fetchAllNonAdminUsers);
    hubx.attachMediator(FETCH_CACHEABLE_CUSTOMERS, new CustomerService().fetchAllCacheable);
    hubx.attachMediator(FETCH_CUSTOMERS, new CustomerService().fetchAll);
    hubx.attachMediator(FETCH_CUSTOMERS_BY_GROUP, new CustomerService().fetchInstallations);
    hubx.attachMediator(FETCH_DIRECTORIES, new DirectorShipService().fetch);
    hubx.attachMediator(FETCH_EXCEL_FILE_CONSUMPTION_HISTORY, new ExportFileService().exportExcelConsumptionHistory);
    hubx.attachMediator(FETCH_EXCEL_FILE_LEVEL_HISTORY, new ExportFileService().exportExcelLevelHistory);
    hubx.attachMediator(FETCH_EXCEL_FILE_TRIPS_HISTORY, new ExportFileService().exportExcelLevelHistory);
    hubx.attachMediator(FETCH_GROUPS, new CustomerService().fetchGroups);
    hubx.attachMediator(FETCH_GROUPS_AND_USERS_FILTERED, new InstallationGroupService().fetchGroupsAndUsers);
    hubx.attachMediator(FETCH_INSTALLATION, new InstallationService().fetch);
    hubx.attachMediator(FETCH_INSTALLATIONS_AND_GROUPS_FILTERED, new InstallationGroupService().fetchFilteredGroupsAndInstallationsIds);
    hubx.attachMediator(FETCH_INSTALLATIONS_IDS, new InstallationGroupService().fetchInstallationsIds);
    hubx.attachMediator(FETCH_INSTALLATION_CONSUMPTION, new InstallationConsumptionService().fetch);
    hubx.attachMediator(FETCH_INSTALLATION_GROUP, new InstallationGroupService().fetch);
    hubx.attachMediator(FETCH_INSTALLATION_GROUPS, new InstallationGroupService().fetchAll);
    hubx.attachMediator(FETCH_INSTALLATION_GROUPS_PAGINATED, new InstallationGroupService().fetchPage);
    hubx.attachMediator(FETCH_INSTALLATION_LEVEL_READINGS, new InstallationLevelService().fetch);
    hubx.attachMediator(FETCH_INSTALLATION_TRIPS_READINGS, new InstallationLevelService().fetchTrips);
    hubx.attachMediator(FETCH_MULTIPLE_INSTALLATIONS, new InstallationService().fetchMultiple);
    hubx.attachMediator(FETCH_MULTIPLE_INSTALLATIONS_CONSUMPTION, new InstallationConsumptionService().fetchMultiple);
    hubx.attachMediator(FETCH_NOTIFICATION_UNREAD, new NotificationService().fetchUnRead);
    hubx.attachMediator(FETCH_ORGANIZATIONS, new OrganizationService().fetch);
    hubx.attachMediator(FETCH_PDF_FILE_FROM_HTML, new ExportFileService().exportPdfFromHtml);
    hubx.attachMediator(FETCH_TANKS_LEVEL_READINGS, new TankLevelService().fetch);
    hubx.attachMediator(FETCH_TANKS_TRIPS_READINGS, new TankLevelService().fetch);
    hubx.attachMediator(FETCH_USER_FAVORITE_INSTALLATIONS, new UserFavoriteInstallationsService().fetchFavoriteInstallations);
    hubx.attachMediator(FETCH_USER_INFO, new UserService().fetch);
    hubx.attachMediator(FETCH_USER_INFO_BY_ID, new UserService().fetchById);
    hubx.attachMediator(FILTER_ALL_INSTALLATIONS, new InstallationService().filter);
    hubx.attachMediator(FILTER_ALL_INSTALLATIONS_NEW, new InstallationService().filterNew);
    hubx.attachMediator(POST_INSTALLATION_GROUP, new InstallationGroupService().create);
    hubx.attachMediator(POST_INSTALLATION_TANKS_READINGS, new InstallationLevelService().update);
    hubx.attachMediator(PUT_INSTALLATION_GROUP, new InstallationGroupService().update);
    hubx.attachMediator(TEST_BEARER_TOKEN, new AuthenticationService().testBearer);
    hubx.attachMediator(FETCH_ALL_VIDEOS_AFTER_SALES, new VideoAfterSalesService().fetchAllVideosAfterSales);
    hubx.attachMediator(TEST_FEDX, _testFedx);
  }
}

async function _testFedx(): Promise<string> {
  // eslint-disable-next-line no-console
  console.log("testing Fedx...");
  return new Promise((res) => {
    setTimeout(() => {
      res("ok!");
    }, 1000);
  });
}
